import variables from 'components/variables';

// eslint-disable-next-line import/prefer-default-export
export const getColor = ({ color, useFallback = true }) => {
  const FALLBACK_COLOR = variables.font;

  const rawColorValue = variables[color];
  const colorCodeExists = Object.values(variables).includes(color);
  const regex = /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/g;

  if (rawColorValue?.match(regex).length > 0) {
    return variables[color];
  }

  if (colorCodeExists && String(color)?.match(regex).length > 0) {
    // return here because it's passing hex color directly
    // and the color is a valid variables color
    // this happens when we do v.grayDark instead of passing string grayDark
    return color;
  }

  if (!useFallback) {
    return undefined;
  }

  if (color) {
    console.warn(`Wrong color name '${color}' provided, using fallback color.`);
  }

  return FALLBACK_COLOR;
};
